import { Action, Mutation, Module } from "vuex-class-modules";
import Axios, { AxiosResponse } from "axios";
import ProfileViewModel from "@/models/ProfileViewModel";
import AxiosSecureModule from "./axiosSecureModule";
import { Log } from "@/plugins/Logging";
@Module({})
export default class ProfileModule extends AxiosSecureModule {
    public profile: ProfileViewModel = new ProfileViewModel();

    @Action
    public async Get() {
        await this.defineHeaderAxios();
        try {
            const result: AxiosResponse = await Axios.get("api/Profile");
            this.Set(result.data);
            return result.data;
        } catch (error) {
            Log.error("", error);
            throw error;
        }
    }
    @Action
    public async Update(model: ProfileViewModel) {
        await this.defineHeaderAxios();
        try {
            const result: AxiosResponse = await Axios.put("api/Profile", model);
            if (result.status === 200) {
                await this.Get();
            }
            return result;
        } catch (error) {
            Log.error("", error);
            throw error;
        }
    }

    @Mutation
    Set(data: ProfileViewModel) {
        this.profile = data;
    }
}
